import React from "react";
import "../Css/style.css";
function InputForm(Props) {
  const { labelName, inputType, value, onchange } = Props;
  return (
    <div className="full-width input-container">
      <label className="mb-2">{labelName}</label>
      <input
        className="full-width borderless entry "
        type={inputType}
        // placeholder={labelName}
        onChange={onchange}
        value={value}
      ></input>
    </div>
  );
}

export default InputForm;
